import * as React from "react"
import type { GatsbyBrowser } from "gatsby"

import "./src/styles/global.css"
import { LeavingSiteInterstitialProvider } from "./src/components"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) =>
  React.createElement(LeavingSiteInterstitialProvider, null, element)
